import { useQuery } from '@tanstack/react-query';
import type { ApiResponse } from '@/shared/api';
import { LOCATION_KEYS } from '../lib';
import { LocationApi } from '../api';
import type { LocationItem } from './types';

export const useRegionItemList = () => {
  return useQuery<ApiResponse<LocationItem[]>>({
    queryKey: LOCATION_KEYS.regions(),
    queryFn: () => LocationApi.getRegions(),
  });
};

export const useDistrictItemList = (parentId?: number) => {
  return useQuery<ApiResponse<LocationItem[]>>({
    queryKey: LOCATION_KEYS.districts(parentId),
    queryFn: () => LocationApi.getDistricts(parentId as number),
    enabled: !!parentId,
  });
};
